module.exports = __webpack_public_path__ + "img/earth-bg.4654137a.png";